/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-08-23 12:56:59
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyWidget } from '../BsyWidget';
import BsyIconBtn from '../BsyIconBtn';
import './index.css'
import { BsyUtils } from '../../utils/Utils';
import tipAlert from '../../Login/BsyAlertTip/Staticize';
import BsyUser from '../BsyUser';
import BsySLoading from '../BsySLoading';
import { dayjsUtils } from '../../utils/dayjsUtils';

export default class BsyBatchTransferPane extends BsyWidget {
    static defaultProps = {

        limit: 500,
        appId: null,
        entryId: null,
        formId: null,
        authGroupId: null,
        idList: [],
        isUpdateAll: !1,
        filter: {},
        onAfterUpdate: null,
        newCharger: null,
        oriCharger: null,
        resultList: [],
        showMode: '',
    }
    constructor(props) {
        super(props);
        this.state = {
            ...props
        }
        this.element = React.createRef();
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.state.showMode === 'showlog') {
            this.batchUpdataList();
        }
    }

    batchUpdata = () => {
        ///data/batch_update
        const { appId, newCharger, oriCharger, isUpdateAll, idList, filter } = this.state;

        React.axios(`/dashboard/app/${appId}/workflow/batch_transfer`, {
            authGroupId: this.props.authGroupId,
            appId: this.props.appId,
            entryId: this.props.entryId || this.props.formId,
            formId: this.props.formId || this.props.entryId,
            newCharger: newCharger,
            oriCharger: oriCharger,
            filter: filter,
            idList: idList,
            isUpdateAll: isUpdateAll,
        })
            .then((res) => {
                this.batchUpdataList();
                if (this.props.onAfterUpdate) {
                    this.props.onAfterUpdate();
                }
            })
            .catch((res) => {
                console.error(res)
            })
    }

    batchUpdataList = () => {
        this.element.current.classList.add('show-loading')
        const { appId } = this.state;
        React.axios(`/dashboard/app/${appId}/workflow/batch_transfer_tasks`, {
            authGroupId: this.props.authGroupId,
            appId: this.props.appId,
            entryId: this.props.entryId || this.props.formId,
            formId: this.props.formId || this.props.entryId,
            limit: 1000,
            skip: 0
        })
            .then((res) => {
                this.element.current.classList.remove('show-loading')
                this.element.current.classList.add('show-result')
                this.setState({
                    resultList: res.data.tasks,
                })
            })
            .catch((res) => {
                console.error(res)
            })
    }

    render() {
        const { newCharger, oriCharger, resultList } = this.state;
        return (
            <div className={"bsy-batch-edit-pane " + (this.state.showMode === 'showlog' ? "show-result" : '')} ref={this.element}>
                <div className='content-main'>
                    <div className="edit-info-item">
                        <p>{React.language('transfer.tip')}</p>
                    </div>

                    <div className="edit-label">{React.language('transfer.charger.original')}</div>
                    <div className="widget-wrapper">
                        <BsyUser

                            value={oriCharger}
                            onStopEdit={(val) => {
                                this.setState({
                                    oriCharger: val,
                                })
                            }}
                        />
                    </div>

                    <div className="edit-label">{React.language('transfer.charger.new')}</div>
                    <div className="widget-wrapper">
                        <BsyUser
                            value={newCharger}
                            onStopEdit={(val) => {
                                this.setState({
                                    newCharger: val,
                                })
                            }}
                        />
                    </div>

                    <div className="edit-footer">
                        <div className="edit-btn-left" onClick={this.batchUpdataList}>{React.language('transfer.record.view')}</div>

                        <BsyIconBtn
                            mode={window.mode}
                            type={'edit-btn'}
                            text={React.language('cancel')}
                            click={(e) => {
                                if (this.props.onCancel) {
                                    this.props.onCancel();
                                }
                            }}
                        />
                        <BsyIconBtn
                            mode={window.mode}
                            text={React.language('ok')}
                            type={"blue edit-btn"}
                            click={(e) => {


                                if (!this.state.oriCharger) {
                                    tipAlert({
                                        type: "warning",
                                        msg: React.language('transfer.charger.original.select')
                                    })
                                    return;
                                }
                                if (!this.state.newCharger) {
                                    tipAlert({
                                        type: "warning",
                                        msg: React.language('transfer.charger.new.select')
                                    })
                                    return;
                                }

                                if (this.state.oriCharger === this.state.newCharger) {
                                    tipAlert({
                                        type: "warning",
                                        msg: React.language('transfer.charger.duplicate')
                                    })
                                    return;
                                }

                                this.batchUpdata();



                                if (this.props.onOk) {
                                    this.props.onOk();
                                }
                            }}
                        />
                    </div>
                </div>
                <div className='content-result'>
                    <div className="title-bar">
                        {
                            !this.state.showMode && <i className="x-icon icon-bsy-left" onClick={() => {
                                this.element.current.classList.remove('show-loading')
                                this.element.current.classList.remove('show-result')
                            }} ></i>
                        }
                        <span>{React.language('transfer.record')}</span></div>
                    {
                        resultList.length === 0 ? <div className='empty-tip'>{React.language('transfer.record.none')}</div>
                            :
                            <div className='record-wrapper'>
                                {
                                    resultList.map((b, index) => {

                                        return <div className="edit-list-item"
                                            key={"edit-list-item" + index}
                                        >
                                            <div className="line-info">{React.language('update.time.label') + BsyUtils.date2Str(dayjsUtils.timeToTZ(b.startTime), "yyyy-MM-dd HH:mm:ss")}      </div>
                                            <div className="line-info">{React.language('transfer.charger.new.label')}<span>{b.task && b.task.newCharger}</span></div>
                                            <div className="line-info">{React.language('transfer.charger.original.label')}<span>{b.task && b.task.oriCharger}</span></div>
                                            <div className="line-info">
                                                <div className="col-4">{React.language("update.dataCount", { count: b.count.total })}</div>
                                                <div className="col-4">{React.language("update.dataCount.success", { count: b.count.success })}</div>
                                                <div className="col-4">{React.language("update.dataCount.fail", { count: b.count.fail })}</div>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                    }
                </div>
                <BsySLoading></BsySLoading>
            </div>
        );
    }
}
